import React, { Component } from 'react'
import { Select, Button } from 'loyal-react'
import ImageUploader from 'react-images-upload'
import '@loyal_molecules/imageuploader.css'
import { ModalSendDocuments } from '../ModalSendDocuments/index'

const documentType = [
  {
    text: 'RG',
    value: 0
  },
  {
    text: 'CNH',
    value: 1
  }
]

class SendDocuments extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showDeleteConfirmation: false,
      isRG: false,
      isCNH: false,
      picturesRG: [],
      picturesCNH: [],
      showSendDocumentsConfirmation: false
    }
    this.onDropRG = this.onDropRG.bind(this)
    this.onDropCNH = this.onDropCNH.bind(this)
  }

  onDropRG (pictureFiles, pictureDataURLs) {
    this.setState({
      picturesRG: this.state.picturesRG.concat(pictureFiles)
    })
  }

  onDropCNH (pictureFiles, pictureDataURLs) {
    this.setState({
      picturesCNH: this.state.picturesCNH.concat(pictureFiles)
    })
  }

  changeDocumentType = (e) => {
    if (e.value === 0) {
      this.setState({
        isRG: true,
        isCNH: false
      })
    } else if (e.value === 1) {
      this.setState({
        isRG: false,
        isCNH: true
      })
    }
  }

  sendRG = () => {
    this.setState({
      showSendDocumentsConfirmation: true
    })
  }

  sendCNH = () => {
    this.setState({
      showSendDocumentsConfirmation: true
    })
  }

  render () {
    return (
      <div>
        <div className='row px-2 py-2'>
          <p className='txt-body'>Escolha um tipo de documento para enviar.</p>
        </div>
        <div className='row mx-0 px-0 pb-2'>
          <Select
            id='DocumentType'
            label='Tipo de documento'
            className='col-12 col-md-3 pr-md-0'
            displayValue='text'
            options={documentType}
            onChange={this.changeDocumentType}
          />
        </div>
        <div className={`row mx-1 px-0 py-2 border-dashed-top border-color-ui-3 ${this.state.isRG ? '' : 'd-none'}`}>
          <p className='col-12 mx-0 px-0 txt-body mb-1'>Tire uma foto digital do seu RG frente e verso. Caso o CPF não esteja identificado no RG enviar uma foto digital do cartão CPF a parte.</p>
          <ImageUploader
            withIcon={false}
            withLabel={false}
            withPreview
            className='rg col-12 col-md-3 px-0 pr-md-1'
            buttonText='RG (frente)'
            onChange={this.onDropRG}
            imgExtension={['.jpg', '.png', '.gif']}
            fileSizeError={'O tamanho deste arquivo excede o limite de 5mb.'}
            fileTypeError={'Este arquivo possui um formato não suportado.'}
            maxFileSize={5242880}
          />
          <ImageUploader
            withIcon={false}
            withLabel={false}
            withPreview
            className='rg col-12 col-md-3 px-0 pr-md-1'
            buttonText='RG (verso)'
            onChange={this.onDropRG}
            imgExtension={['.jpg', '.png', '.gif']}
            fileSizeError={'O tamanho deste arquivo excede o limite de 5mb.'}
            fileTypeError={'Este arquivo possui um formato não suportado.'}
            maxFileSize={5242880}
          />
          <ImageUploader
            withIcon={false}
            withLabel={false}
            withPreview
            className='rg col-12 col-md-3 px-0 pr-md-1'
            buttonText='Cartão CPF'
            onChange={this.onDropRG}
            imgExtension={['.jpg', '.png', '.gif']}
            fileSizeError={'O tamanho deste arquivo excede o limite de 5mb.'}
            fileTypeError={'Este arquivo possui um formato não suportado.'}
            maxFileSize={5242880}
          />
          <div className='col-12 col-md-3 mt-1 px-0 mx-0'>
            <Button
              className='btn btn-sm btn-featured txt-button txt-center txt-font-body-bold'
              text='Enviar'
              disabled={this.state.picturesRG.length !== 2}
              onClick={() => this.sendRG()}
            />
          </div>
        </div>
        <div className={`row mx-1 px-0 py-2 border-dashed-top border-color-ui-3 ${this.state.isCNH ? '' : 'd-none'}`}>
          <p className='col-12 mx-0 px-0 txt-body mb-1'>Tire uma foto digital da sua CNH.</p>
          <ImageUploader
            withIcon={false}
            withLabel={false}
            withPreview
            className='cnh col-12 col-md-3 px-0 pr-md-1'
            buttonText='CNH (frente)'
            onChange={this.onDropCNH}
            imgExtension={['.jpg', '.png', '.gif']}
            fileSizeError={'O tamanho deste arquivo excede o limite de 5mb.'}
            fileTypeError={'Este arquivo possui um formato não suportado.'}
            maxFileSize={5242880}
          />
          <div className='col-12 col-md-3 mt-1 px-0 mx-0'>
            <Button
              className='btn btn-sm btn-featured txt-button txt-center txt-font-body-bold'
              text='Enviar'
              disabled={this.state.picturesCNH.length !== 1}
              onClick={() => this.sendCNH()}
            />
          </div>
        </div>
        <ModalSendDocuments
          show={this.state.showSendDocumentsConfirmation}
          onCloseButton={e => this.setState({ showSendDocumentsConfirmation: false })}
          onClose={e => this.setState({ showSendDocumentsConfirmation: false })}
        />
      </div>
    )
  }
}

export default SendDocuments



// WEBPACK FOOTER //
// ./src/Participant/TwoStepVerification/SendDocuments/SendDocuments.js